export var WendysLaborRoutes = {
    "/wendys-labor": {
        "loginRequired": true,
        "name": "appLayout.schedule.wendys-labor",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "laborWeeksListContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./wendys-labor.module.js");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["wendys-labor"]
        },
        "onEnter": ['userServices', '$state', 'TeamScheduleService', 'hUser',
            function (userServices, $state, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        userServices.isServiceEnabled(userServices.SERVICES.WENDYS_LABOR_MODEL, brand.id)
                            .then(function (isWendysLaborServiceEnabled) {
                                if (!isWendysLaborServiceEnabled || !hUser.hasSalesAccess()) {
                                    $state.go("appLayout.schedule.main");
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    },
    "/wendys-labor-projections?date": {
        "loginRequired": true,
        "name": "appLayout.schedule.wendys-labor-projections",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "wendysLaborProjectionsContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./wendys-labor.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../../hmodules/activity-based-scheduling/activity-based-scheduling.module.js");
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["wendys-labor"]
        },
        "onEnter": ['userServices', '$state', 'TeamScheduleService', 'hUser',
            function (userServices, $state, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        userServices.isServiceEnabled(userServices.SERVICES.WENDYS_LABOR_MODEL, brand.id)
                            .then(function (isWendysLaborServiceEnabled) {
                                if (!isWendysLaborServiceEnabled || !hUser.hasSalesAccess()) {
                                    $state.go("appLayout.schedule.main");
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    }
};
